import type { TPropertyTypeV2 } from './property-v2.interface'

export type TPublishingStatus =
  | 'DRAFT'
  | 'PUBLISHED'
  | 'NOT_PUBLISHED'
  | 'DELETED'
  | 'PENDING'
  | 'PENDING_TO_APROVE'
  | 'PENDING_TO_ASSIGN'
  | 'DELETED_RECENTLY'

export type TPropertyOperation = 'SALE' | 'PRESALE' | 'LEASE'

export type TPropertyUseTypeV2 =
  | 'COMMERCIAL_INDUSTRIAL'
  | 'MIXED_RESIDENTIAL_COMMERCIAL'
  | 'RESIDENTIAL'
  | 'TOURIST'

export const useLandPropertyTypeCheckboxLabel = {
  'RESIDENTIAL-HOUSE': 'Casa',
  'RESIDENTIAL-HOUSE-CONDOMINIUM': 'Casa en condominio',
  'RESIDENTIAL-APARTMENT': 'Departamento',
  'RESIDENTIAL-COUNTRY_HOUSE': 'Quinta campestre',
  'RESIDENTIAL-TERRAIN': 'Terreno residencial',
  'COMMERCIAL_INDUSTRIAL-TERRAIN': 'Terreno comercial',
  'COMMERCIAL_INDUSTRIAL-SHOP': 'Local',
  'COMMERCIAL_INDUSTRIAL-OFFICE': 'Oficina',
  'COMMERCIAL_INDUSTRIAL-WAREHOUSE': 'Bodega',
  'MIXED_RESIDENTIAL_COMMERCIAL-TERRAIN': 'Terreno uso residencial o comercial',
  'MIXED_RESIDENTIAL_COMMERCIAL-SHOP_SHOPPING_CENTER':
    'Local en centro comercial',
  'MIXED_RESIDENTIAL_COMMERCIAL-HOUSE': 'Casa uso residencial u oficinas',
  'COMMERCIAL_INDUSTRIAL-BUILDING': 'Edificio comercial/industrial',
  'TOURIST-APARTMENT': 'Departamento uso turístico',
  'TOURIST-TERRAIN': 'Terreno uso turístico',
  'TOURIST-HOUSE': 'Casa uso turístico',
  'MIXED_RESIDENTIAL_COMMERCIAL-RANCH': 'Rancho / hacienda',
  'COMMERCIAL_INDUSTRIAL-INDUSTRIAL_BUILDING': 'Nave industrial',
  'COMMERCIAL_INDUSTRIAL-CONSULTING_ROOM': 'Consultorio médico',
  'TOURIST-HOTEL': 'Hotel',
  'TOURIST-COTTAGE': 'Cabaña',
  'RESIDENTIAL-DUPLEX_HOUSE': 'Casa duplex',
  'RESIDENTIAL-BUILDING': 'Edificio residencial',
  'MIXED_RESIDENTIAL_COMMERCIAL-BUILDING':
    'Edificio uso residencial o comercial',
  'COMMERCIAL_INDUSTRIAL-EVENT_HALL': 'Salón de eventos'
}

export type TPropertyBy =
  | 'BY_EXTERNAL_BROKER'
  | 'BY_ME'
  | 'BY_SAME_AGENCY_BROKER'
  | null
export type TPropertyEvent = 'REQUESTED_TO_DELETE'
export type TPropertyOtherReason = string | null
export type TPropertyReason =
  | 'ALREADY_TRADED'
  | 'AUTHORIZATION_LOST'
  | 'OTHER'
  | 'ALREADY_SOLD'
export type TPropertyRemoveReason =
  | 'TRADED'
  | 'AUTHORIZATION_LOST'
  | 'OTHER'
  | 'SOLD'

export type TPropertyPreservation = 'GOOD' | 'EXCELENT' | 'REGULAR' | 'BAD'

export type TPropertyAntiquity = 'USED' | 'NEW' | 'CONSTRUCTION'

export type TPropertyPendingType = 'PENDING_TO_ASSIGN' | 'PENDING_TO_APROVE'

export type TPropertyUseType = 'HABITACIONAL' | 'COMMERCIAL' | 'TOURIST'

export type TPropertyGroundShape = 'REGULAR' | 'IRREGULAR'

export type TPropertyGroundRelief = 'FLAT' | 'TILTED'

export interface IUser {
  userId?: number
  agencyId?: number | null
  agencyLogo?: string | null
  agencyName?: string | null
  completed?: boolean
  email?: string | null
  fullname?: string | null
  phoneNumber?: string | null
  photo?: string | null
  profileId?: string | null
}
export interface IPropertyDetail {
  addressReference: string
  agencyId: number
  agencyLogo: string
  agencyName: string
  agencyOwned: number
  amenities: string[]
  antiquity: string
  antiquityYears: number
  associations: any[]
  bathrooms: number
  bedrooms: number
  brokerName: string
  brokerPhoto: string
  buildingFloors?: number | null
  city: string
  constructionSize: number
  contactEmail: string
  contactPhone: string
  country: string | null
  coveredParking: boolean | null
  coverImage: string
  deliveryMonth: string | null
  deliveryYear: string | null
  description: string
  descriptionEn: string | null
  externalNumber: null | string
  extraAmenities: any[]
  failurePortalIds: any[]
  floors: number
  groundRelief: string
  groundShape: string
  groundSize: number
  halfBathrooms: number
  hasServiceRoom: boolean
  images: string[]
  inAnAssociation: boolean
  insideCondo: boolean
  internalNumber: string | null
  isMacrobolsa: boolean
  pendingPortalIds: string[]
  pendingType?: TPropertyPendingType
  latitude: number
  leaseActive: boolean | null
  leaseAnticipatedRents: number
  leaseCommission: null
  leaseCurrency: null | string
  leaseDepositMonths: number
  leaseEndorsement: boolean
  leaseForcedContractMonths: number
  leaseMaintenanceCurrency: string
  leaseMaintenancePrice: number | null
  leaseOpportunities: number
  leasePrice: number | null
  leaseResearch: boolean
  leaseRestrictions: string
  leaseShareCommission: boolean | null
  leaseSharedCommission: number | null
  legalStatus: string
  length: number | null
  locatedAtFloor?: number | null
  longitude: number
  matches: number
  matterportUrl: string | null
  matterportURL: string | null
  modifiedAt: string
  neighborhood: string
  notes: string
  offereds: number
  parkingLots: number
  portalCyt?: boolean
  portalCytLastSync?: string
  portalCytLeads: number
  portalCytLink?: string
  portalCytStatus: string
  portalElinformador?: boolean
  portalElinformadorLastSync?: string
  portalElinformadorLeads: number
  portalElinformadorStatus: string
  portalExcelsior?: boolean
  portalExcelsiorLastSync?: string
  portalExcelsiorLeads: number
  portalExcelsiorLink?: string
  portalExcelsiorStatus: string
  portalFailures: boolean
  portalLamudi?: boolean
  portalMonopolio?: boolean
  portalMonopolioFailure?: string
  portalMonopolioLastSync?: string
  portalMonopolioLeads: number
  portalMonopolioLink?: string
  portalMonopolioStatus: string
  portalPortalterrenocom?: boolean
  portalPortalterrenocomLastSync?: string
  portalPortalterrenocomLeads: number
  portalPortalterrenocomLink?: string
  portalPortalterrenocomStatus: string
  portalPropiedadescom?: boolean
  portalPropiedadescomLastSync?: string
  portalPropiedadescomLeads: number
  portalPropiedadescomLink?: string
  portalPropiedadescomStatus: string
  portalWiggot: boolean
  portalWiggotLink?: string
  portalWiggotGuadalajara?: boolean
  portalWiggotLastSync: string
  portalWiggotLeads: number
  portalWiggotStatus: string
  portalI24Link?: string
  portalM3Link?: string
  portalLamudiLink?: string
  portalAllPropertyLink?: string
  portalElinformadorLink?: string
  postalCode: string
  presaleAboutTheContract: string | null
  presaleActive: boolean | null
  presaleCashPayment: number | null
  presaleCommission: number | null
  presaleCreditDetails: number | null
  presaleCreditPayment: number | null
  presaleCurrency: string | null
  presaleMaintenanceCurrency: number | null
  presaleMaintenancePrice: number | null
  presaleOpportunities: number
  presalePrice: number | null
  presaleShareCommission: boolean | null
  presaleSharedCommission: number | null
  preservation: TPropertyPreservation
  profileCompleted: boolean
  profileId: string
  profileScore?: number
  propertyAge?: number
  propertyId: string
  propertyType: TPropertyTypeV2
  publishedAt: string
  publishedInAssociations: {
    id: number
    name: string
    logo: string
    publishedAt: string
    shortName: string
  }[]
  publishedPortalIds: string[]
  publishingStatus: TPublishingStatus
  reports: IPropertyReports
  reportsCount: number
  requestToDelete: boolean
  saleAboutTheContract: string | null
  saleActive: boolean | null
  saleCashPayment: boolean
  saleCommission: number | null
  saleCreditDetails: string
  saleCreditPayment: boolean
  saleCurrency: null | string
  saleMaintenanceCurrency: string
  saleMaintenancePrice: number | null
  saleOpportunities: number
  salePrice: number | null
  saleShareCommission: boolean | null
  saleSharedCommission: number | null
  score: number
  state: string
  staticMap: string
  status?: boolean
  street: string
  title: null | string
  titleEn: string | null
  toBeDeletedAt: string | null
  unassignedProperty: number
  unencumberedProperty: boolean
  unavailable?: boolean
  updatingPortalIds: string[]
  useComercial: boolean
  useResidential: boolean
  userId: number
  userOwned: number
  userScoresSectionConfig: string
  useTourist: boolean
  warnings: number
  width: number
  wiggotBoost: boolean
  wiggotPass: boolean
  youtubeUrl: string | null
  youtubeURL: string | null
  propertyStatus?: string
  user?: IUser
  legacyId?: string
  ownerId?: string
  assignedUserId?: string
}

export interface IPropertyReports {
  incomplete: number | string | null
  incompleteCount: number
  lastIncomplete: number | string | null
  unavailable: number | string | null
  unavailableCount: number
  lastUnavailable: number | string | null
  allReports: number
}

export interface IPropertyPerformance {
  publishedAt: string
  modifiedAt: string
  superMatches: number
  matches: number
  totalMatches: number
  wiggotLeads: IPropertyLeads
  wiggotBoostLeads: IPropertyLeads
  websiteLeads: IPropertyLeads
  portalLeads: IPropertyLeads
  totalLeads: number
  totalOfferings: number
  totalViews: number
  totalPdfDonwloads: number
  totalLinks: number
  totalDatasheets: number
  wiggotBoost: boolean
}

export interface IPropertyProspects {
  id: string
  name: string
  opportunityCount: number
  shortName: string
}
export interface IPropertyLeads {
  count: number
  lastLeadYear: string
}

export interface IResponseProperties {
  total: number
  pages: number
  page: number
  sections: {
    expiring: number
    pending: number
  }
  properties: IPropertyDetail[]
}

export interface IAmenity {
  id: string
  createdAt: string
  deletedAt: string | null
  updatedAt: string
  uniqueId: string
  name: string
  isActive: boolean
  icon: string
}

export interface IResponseAmenities {
  generalAmenities: IAmenity[]
  mostCommonAmenities: IAmenity[]
}

export interface IResponseRawDatasheet {
  datasheet: ICustomDatasheet
}

export interface ICustomDatasheet {
  datasheetId: string
  coverImage: string
  title: string
  description: string
  images: string[]
}

export interface IMonopolioPropertyMetricsMarketEstimate {
  listingType?: 'for-sale' | 'for-rent'
  price?: number | null
  surface?: number | null
  predictionPriceSale?: number | null
  predictionPriceRent?: number | null
  capRate?: number | null
  predictionPricePerSquareMeterRent?: number | null
  predictionPricePerSquareMeterSale?: number | null
  predictionPricePerSquareMeterLower?: number | null
  predictionPricePerSquareMeterUpper?: number | null
  salePriceDiffPercent: number | null
  rentPriceDiffPercent: number | null
}

export interface IMonopolioPropertyMetrics {
  hasMarketEstimate: boolean
  marketEstimate?: IMonopolioPropertyMetricsMarketEstimate | null
}
